import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c8d974d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c8d974d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d974d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8d974d')) {
      api.createRecord('1c8d974d', component.options)
    } else {
      api.reload('1c8d974d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c8d974d&scoped=true", function () {
      api.rerender('1c8d974d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/PayThirdBack/index.vue"
export default component.exports